const zh_CN = {
  section: "块",
  nft_burnt: "NFT销毁",
  total_burnt: "销毁总量",
  burnt_30_days: "近30天的销毁量",
  burnt_log: "近期销毁记录",
  time: "时间",
  hash: "哈希地址",
  amount: "数量",
  article_title: "廉正举报须知",
  load_more: "加载更多",
  article_info_1:
    "AINFT基金会致力于诚信且基于道德的最佳实践和原则（包括反贿赂和反腐败合规标准）开展业务。AINFT基金会对贿赂和腐败零容忍度。",
  article_info_2:
    "如您知悉或怀疑AINFT基金会的任何员工或顾问或相关人士或其关联人，或声称其为AINFT基金会员工或顾问的任何人士有向您索取贿赂的行为，请立即通知AINFT基金会并将全部相关详情发送至邮箱",
  article_info_3:
    "AINFT基金会会对所有信息提供者及其提供的全部信息严格保密，并采取如下措施为您提供多重保障:",
  article_info_4:
    "1. 无论您主动还是被动向AINFT基金会任何员工或其相关人士或该等人士的关联人提供不正当利益或好处，如在AINFT基金会通过其他途径获悉该等信息之前，您主动向AINFT基金会提供有效信息并说明情况，AINFT基金会可以自行决定根据实际情形进行考量，继续与您进行商业合作。AINFT基金会可以对您违反任何上述规定不予追究。",
  article_info_5:
    "2. 对于向AINFT基金会提供的相关商业贿赂行为的信息一经查实，AINFT基金会应根据商业贿赂行为的影响程度给予信息提供者酬金。",
};

export default zh_CN